export class EligibiliteBeneficiaire {
    id: number;
    name: string;
}


